import type { ZReportLayoutConfig, ZReportLayoutEntry, ZReportLayoutEntryType } from 'shared-models/browser';

type CatalogEntry = {
  key: string;
  type: ZReportLayoutEntryType;
  label: string;
  sectionKey?: string;
  bold?: boolean;
};

export const Z_REPORT_LAYOUT_CATALOG: ReadonlyArray<CatalogEntry> = [
  { key: 'section:salesSummary', type: 'section', label: 'סיכום מכירות' },
  { key: 'row:salesWithOpenOrders', type: 'row', label: 'סה"כ מכירות עם הזמנות פתוחות (לא כולל טיפים)', sectionKey: 'section:salesSummary' },
  { key: 'row:openOrdersTotal', type: 'row', label: 'סכום כולל הזמנות פתוחות (לא כולל טיפים)', sectionKey: 'section:salesSummary' },
  { key: 'row:openOrdersCount', type: 'row', label: 'כמות הזמנות פתוחות', sectionKey: 'section:salesSummary' },
  { key: 'row:closedRevenue', type: 'row', label: 'סה"כ הכנסות - הזמנות סגורות (לא כולל טיפים)', sectionKey: 'section:salesSummary' },
  { key: 'row:vatAmount', type: 'row', label: 'מע"מ', sectionKey: 'section:salesSummary' },
  { key: 'row:dinersCount', type: 'row', label: 'סה"כ סועדים', sectionKey: 'section:salesSummary' },
  { key: 'row:canceledItemsCount', type: 'row', label: 'ביטול פריטים (כמות)', sectionKey: 'section:salesSummary' },
  { key: 'row:canceledItemsAmount', type: 'row', label: 'ביטול פריטים (סכום)', sectionKey: 'section:salesSummary' },
  { key: 'row:discountsAmount', type: 'row', label: 'הנחות (סכום)', sectionKey: 'section:salesSummary' },
  { key: 'row:canceledOrdersCount', type: 'row', label: 'הזמנות מבוטלות (כמות)', sectionKey: 'section:salesSummary' },
  { key: 'row:avgPerDiner', type: 'row', label: 'ממוצע לסועד (לא כולל טיפים)', sectionKey: 'section:salesSummary' },
  { key: 'row:avgPerDinerTakeAway', type: 'row', label: 'ממוצע לסועד - מהירה', sectionKey: 'section:salesSummary' },
  { key: 'row:tipsTotalMain', type: 'row', label: 'סה"כ טיפים (סכום טיפים כולל)', sectionKey: 'section:salesSummary' },

  { key: 'section:salesByCategory', type: 'section', label: 'פירוט הכנסות לפי קטגוריה' },
  { key: 'row:salesByReportGroupFood', type: 'row', label: 'אוכל', sectionKey: 'section:salesByCategory' },
  { key: 'row:salesByReportGroupBeverages', type: 'row', label: 'משקאות', sectionKey: 'section:salesByCategory' },
  { key: 'row:salesByReportGroupOther', type: 'row', label: 'אחר', sectionKey: 'section:salesByCategory' },

  { key: 'section:tipsByPayment', type: 'section', label: 'טיפים לפי סוג תשלום' },
  { key: 'row:tipsCredit', type: 'row', label: 'טיפים אשראי', sectionKey: 'section:tipsByPayment' },
  { key: 'row:tipsCash', type: 'row', label: 'טיפים מזומן', sectionKey: 'section:tipsByPayment' },
  { key: 'row:tipsTotalSection', type: 'row', label: 'סה"כ טיפים', sectionKey: 'section:tipsByPayment', bold: true },
  { key: 'row:tipsStationary', type: 'row', label: 'טיפים עמדה נייחת', sectionKey: 'section:tipsByPayment' },

  { key: 'section:receiptsSummary', type: 'section', label: 'סיכום סוגי תקבולים' },
  { key: 'row:receiptsCash', type: 'row', label: 'תקבול מזומן (כולל טיפים)', sectionKey: 'section:receiptsSummary' },
  { key: 'row:receiptsCredit', type: 'row', label: 'תקבול אשראי (כולל טיפים)', sectionKey: 'section:receiptsSummary' },
  { key: 'row:receiptsTotal', type: 'row', label: 'סה"כ תקבולים', sectionKey: 'section:receiptsSummary', bold: true },

  { key: 'section:paymentsSummary', type: 'section', label: 'סיכום סוגי תשלומים' },
  { key: 'row:paymentsCredit', type: 'row', label: 'אשראי (לא כולל טיפים)', sectionKey: 'section:paymentsSummary' },
  { key: 'row:paymentsCash', type: 'row', label: 'מזומן (לא כולל טיפים)', sectionKey: 'section:paymentsSummary' },
  { key: 'row:paymentsTotal', type: 'row', label: 'סה"כ סוגי תשלום', sectionKey: 'section:paymentsSummary', bold: true },

  { key: 'section:paymentDetails', type: 'section', label: 'פירוט סוגי תשלומים' },
  { key: 'row:creditCharges', type: 'row', label: 'אשראי - סה"כ חיובים (לא כולל טיפים)', sectionKey: 'section:paymentDetails' },
  { key: 'row:creditRefunds', type: 'row', label: 'אשראי - סה"כ זיכויים', sectionKey: 'section:paymentDetails' },
  { key: 'row:creditTotal', type: 'row', label: 'אשראי - סה"כ אשראי', sectionKey: 'section:paymentDetails', bold: true },
  { key: 'row:cashCharges', type: 'row', label: 'מזומן - סה"כ חיובים (לא כולל טיפים)', sectionKey: 'section:paymentDetails' },
  { key: 'row:cashRefunds', type: 'row', label: 'מזומן - סה"כ זיכויים', sectionKey: 'section:paymentDetails' },
  { key: 'row:cashTotal', type: 'row', label: 'מזומן - סה"כ מזומן', sectionKey: 'section:paymentDetails', bold: true },

  { key: 'section:invoices', type: 'section', label: 'חשבוניות שהופקו' },
  { key: 'row:chargeTransactionsCount', type: 'row', label: 'עסקאות חיוב', sectionKey: 'section:invoices' },
  { key: 'row:refundTransactionsCount', type: 'row', label: 'עסקאות זיכוי', sectionKey: 'section:invoices' },

  { key: 'section:drawers', type: 'section', label: 'פירוט מגירות מזומן' },
  { key: 'row:drawerHeader', type: 'row', label: 'כותרת מגירה (שם מדפסת)', sectionKey: 'section:drawers' },
  { key: 'row:drawerCashTotalWithTips', type: 'row', label: 'סה"כ מזומן (כולל טיפים)', sectionKey: 'section:drawers' },
  { key: 'row:drawerTipsTotal', type: 'row', label: 'מתוכם סה"כ טיפים', sectionKey: 'section:drawers' },
  { key: 'row:openingCash', type: 'row', label: 'מזומן פתיחה', sectionKey: 'section:drawers', bold: true },
  { key: 'row:countedCash', type: 'row', label: 'מזומן נספר בקופה', sectionKey: 'section:drawers', bold: true },
  { key: 'row:cashMinusCreditTips', type: 'row', label: 'סה"כ מזומן בהפחתת טיפים אשראי ומזומן', sectionKey: 'section:drawers', bold: true },
  { key: 'row:expectedCash', type: 'row', label: 'מזומן צפוי בקופה', sectionKey: 'section:drawers', bold: true },
];

const byKey = new Map<string, CatalogEntry>(Z_REPORT_LAYOUT_CATALOG.map((entry) => [entry.key, entry]));

export function buildDefaultZReportLayoutConfig(): ZReportLayoutConfig {
  return {
    version: 1,
    entries: Z_REPORT_LAYOUT_CATALOG.map((entry) => ({
      key: entry.key,
      type: entry.type,
      visible: true,
      bold: entry.bold ?? false,
      negative: false,
      label: entry.label,
    })),
  };
}

export function mergeZReportLayoutConfig(input: ZReportLayoutConfig | null | undefined): ZReportLayoutConfig {
  const defaults = buildDefaultZReportLayoutConfig();
  if (!input) {
    return defaults;
  }

  const defaultsByKey = new Map(defaults.entries.map((entry) => [entry.key, entry] as const));

  const normalizedEntries: ZReportLayoutEntry[] = [];
  for (const entry of input.entries) {
    if (entry.type === 'section') {
      const sectionBase = defaultsByKey.get(entry.key);
      if (!sectionBase || sectionBase.type !== 'section') {
        continue;
      }
      normalizedEntries.push({
        key: sectionBase.key,
        type: 'section',
        visible: entry.visible,
        bold: false,
        negative: false,
        label: entry.label?.trim() || sectionBase.label,
      });
      continue;
    }

    const canonicalRowKey = defaultsByKey.get(entry.key)?.type === 'row'
      ? entry.key
      : (entry.sourceKey ?? '');
    const rowBase = defaultsByKey.get(canonicalRowKey);
    if (!canonicalRowKey || !rowBase || rowBase.type !== 'row') {
      continue;
    }

    normalizedEntries.push({
      key: entry.key,
      sourceKey: canonicalRowKey === entry.key ? undefined : canonicalRowKey,
      type: 'row',
      visible: entry.visible,
      bold: entry.bold ?? rowBase.bold ?? false,
      negative: entry.negative ?? rowBase.negative ?? false,
      label: entry.label?.trim() || rowBase.label,
    });
  }

  const presentCanonicalKeys = new Set(
    normalizedEntries
      .filter((entry) => entry.type === 'row')
      .map((entry) => entry.sourceKey ?? entry.key),
  );

  const missingDefaults = defaults.entries.filter((entry) => {
    if (entry.type === 'section') {
      return !normalizedEntries.some((candidate) => candidate.type === 'section' && candidate.key === entry.key);
    }
    return !presentCanonicalKeys.has(entry.key);
  });

  const mergedEntries: ZReportLayoutEntry[] = [...normalizedEntries, ...missingDefaults];

  return {
    version: 1,
    entries: mergedEntries,
  };
}

export function getZReportLayoutCatalogEntry(key: string): CatalogEntry | null {
  return byKey.get(key) ?? null;
}

export function getDefaultLabelForKey(key: string): string {
  return byKey.get(key)?.label ?? key;
}
